<template>
  <FilterPracticeOptions v-model="selected" :options="options">
    Thematische Gruppen
  </FilterPracticeOptions>
</template>

<script setup>
import { ref, computed, onMounted, watchEffect } from 'vue';
import client from '@/client';

const props = defineProps({'modelValue': Array});
const emits = defineEmits(['update:modelValue']);

const results = ref(new Array);
const selected = ref(new Array);

const mapping = (keyword) => ({label: keyword.title, value: keyword.handle});
const options = computed(() => results.value.map(mapping));

const mount = onMounted(() =>
{
  client.get('/api/keywords')
  .then(result => results.value = result.data.data)
  .catch(error => results.value = []);
});

const onUpdate = watchEffect(() =>
{
  const event = 'update:modelValue';
  const value = selected.value;
  emits(event, value);
});
</script>
